import { computed } from 'vue';

import { useCurrentUserStore } from './useCurrentUserStore';

export default function useCurrentUserId() {
  const currentUserStore = useCurrentUserStore();

  return computed(() => currentUserStore.user?.id ?? null);
}
